import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { registerUser as registerUserAPI } from 'services/apiAuth1';

const useUserRegistration = (setOrgExistsModal) => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {isPending,mutate: registerUser} = useMutation({
        mutationFn:(data)=> registerUserAPI(data),
        onSuccess:(data)=>{
            queryClient.setQueryData(['mfa-session'],data)
            navigate('/mfa-verify',{replace:true})
        },
        onError:(error)=>{
            console.log("Signup error:", error);
             if (error?.data?.code === "ORG_EXISTS") {
                setOrgExistsModal(true);
                return;
            }

            if (error?.data && typeof error.data === 'object'){
                for (const key in error.data) {
                const messages = error.data[key]
                const message = Array.isArray(messages) ? messages[0] : messages
                toast.error(message)
                }
            }else{
                toast.error("Something went wrong. Please try again.")
            }
        }
    })

    return {isPending,registerUser}
}

export default useUserRegistration
